import styled from "styled-components";
import inputStyles from "../../theme/inputStyles";
import { Field } from "formik";

export const StyledTextArea = styled(Field)`
  ${inputStyles};
  min-height: 15rem;
  padding: 1rem 0.9rem;
`;
